export const BLANK_ID = "blank";
export const STANDARD_ID = "standard";
